import makeStyles from "@mui/styles/makeStyles";
export var useCarouselStyles = makeStyles(function () { return ({
    root: {},
}); });
